import { createSlice } from '@reduxjs/toolkit';

const selectedDataProviderSlice = createSlice({
    name: 'selectedDataProvider',
    initialState: {
        dataProviderId: null,
        dataProviderName: null,
        dataProviderDisplayName: null,
    },
    reducers: {
        setSelectedDataProvider: (state, action) => {
            const { dataProviderId, dataProviderName, dataProviderDisplayName } = action.payload;
            state.dataProviderId = dataProviderId;
            state.dataProviderName = dataProviderName;
            state.dataProviderDisplayName = dataProviderDisplayName;
        },
        clearSelectedDataProvider: (state) => {
            state.dataProviderId = null;
            state.dataProviderName = null;
            state.dataProviderDisplayName = null;
        }
    }
});

export const { setSelectedDataProvider, clearSelectedDataProvider } = selectedDataProviderSlice.actions;

// Selectors
export const selectSelectedDataProviderId = (state) => state.selectedDataProvider.dataProviderId;
export const selectSelectedDataProviderName = (state) => state.selectedDataProvider.dataProviderName;
export const selectSelectedDataProviderDisplayName = (state) => state.selectedDataProvider.dataProviderDisplayName;

export default selectedDataProviderSlice.reducer;